import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {type Appareil, getAppareilTypeLabel} from "@mytour/shared";
import {useState} from "react";

type Props = {
  appareils: Appareil[];
};

export function ApplianceRecapCard({appareils}: Props) {
  const [appareilIndex, setAppareilIndex] = useState(0);
  const appareilCount = appareils.length;

  const [previousAppareilCount, setPreviousAppareilCount] = useState(appareilCount);
  if (appareilCount !== previousAppareilCount) {
    setPreviousAppareilCount(appareilCount);
    setAppareilIndex(0);
  }

  const appareil = appareils[appareilIndex];
  if (!appareil) {
    return null;
  }
  const appareilTypeLabel = getAppareilTypeLabel(appareil);

  return (
    <div style={{marginBottom: "16px", fontSize: "14px"}}>
      {appareilCount > 1 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "12px",
          }}
        >
          <NavArrowButton
            icon="chevron-left"
            label="Appareil précédent"
            disabled={appareilIndex === 0}
            onClick={handlePreviousAppareil}
          />
          <div style={{textAlign: "center"}}>
            <div style={{fontWeight: 700}}>
              Appareil {appareilIndex + 1} sur {appareilCount}
            </div>
            <div style={{fontSize: "12px", color: "#6c757d"}}>
              {appareilTypeLabel} · {appareil.appareilEmplacement}
            </div>
          </div>
          <NavArrowButton
            icon="chevron-right"
            label="Appareil suivant"
            disabled={appareilIndex === appareilCount - 1}
            onClick={handleNextAppareil}
          />
        </div>
      )}

      <div
        style={{
          border: "1px solid #dee2e6",
          borderRadius: "4px",
          padding: "8px 12px",
        }}
      >
        <p>
          <strong>Appareil :</strong> {appareilTypeLabel} ({appareil.combustible})
        </p>
        <p>
          <strong>Emplacement :</strong> {appareil.appareilEmplacement}
        </p>
        <p>
          <strong>Conduit :</strong> {appareil.conduitType}
        </p>
        <p>
          <strong>Nature :</strong> {appareil.natureIntervention.join(", ")}
        </p>
        <p>
          <strong>Nettoyage :</strong> {appareil.nettoyageAction} - {appareil.nettoyageOutil}
        </p>
        <p>
          <strong>Tirage :</strong>{" "}
          {appareil.tirage === "conforme"
            ? "Conforme"
            : appareil.tirage === "nonConforme"
              ? "Non conforme"
              : "Non vérifié"}
        </p>
        <p>
          <strong>Vacuité :</strong> {appareil.attestationVacuite ? "Attestée" : "Non attestée"}
        </p>
        {appareil.remarques && (
          <p>
            <strong>Remarques :</strong> {appareil.remarques}
          </p>
        )}
      </div>

      {appareilCount > 1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "6px",
            marginTop: "8px",
          }}
        >
          {appareils.map((_, index) => (
            <span
              key={index}
              style={{
                width: "6px",
                height: "6px",
                borderRadius: "50%",
                backgroundColor: index === appareilIndex ? "var(--mt-color-action)" : "#dee2e6",
              }}
            />
          ))}
        </div>
      )}
    </div>
  );

  function handlePreviousAppareil() {
    setAppareilIndex((index) => Math.max(0, index - 1));
  }

  function handleNextAppareil() {
    setAppareilIndex((index) => Math.min(appareilCount - 1, index + 1));
  }
}

type NavArrowButtonProps = {
  icon: "chevron-left" | "chevron-right";
  label: string;
  disabled: boolean;
  onClick: () => void;
};

function NavArrowButton({icon, label, disabled, onClick}: NavArrowButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      onClick={onClick}
      disabled={disabled}
      style={{
        width: "32px",
        height: "32px",
        borderRadius: "50%",
        border: "1px solid #dee2e6",
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? "default" : "pointer",
      }}
    >
      <FontAwesomeIcon icon={icon} />
    </button>
  );
}
